import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  TextField,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormContext } from "../context/formContext";
import Button from "@common/components/Button";

interface AddEventDialogProps {
  open?: boolean;
  onClose?: () => void;
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  "& .MuiFormHelperText-root": {
    color: theme.palette.error.main,
  },
  "& .MuiInputLabel-root::after": {
    content: "'*'",
    color: theme.palette.error.main,
  },
}));

const AddEventDialog = (props: AddEventDialogProps) => {
  const { form, dispatchDetails, dispatchHasChanged } = useContext(FormContext);
  const { ticket, details } = form;
  const { open = false, onClose = () => {} } = props;
  const { t } = useTranslation();
  const [name, setName] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [errorComment, setErrorComment] = useState<string>("");
  const [errorName, setErrorName] = useState<string>("");

  const onConfirm = async () => {
    setErrorComment("");
    setErrorName("");

    if (comment !== "" && name !== "") {
      dispatchDetails({
        events: [
          ...(details?.events ?? []),
          {
            subject: name,
            description: comment,
            priority: ticket.priority,
            createDate: new Date().getTime(),
          },
        ],
      });
      dispatchHasChanged(true);
      setName("");
      setComment("");
      onClose();
    } else {
      if (comment === "") setErrorComment(t("Field is required"));
      if (name === "") setErrorName(t("Field is required"));
    }
  };

  const onCancel = () => {
    setErrorComment("");
    setErrorName("");
    setComment("");
    setName("");
    onClose();
  };

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle>{t("Create Event")}</DialogTitle>
      <DialogContent>
        <StyledFormControl fullWidth>
          <TextField
            sx={{ mt: 1 }}
            id="comment_textfield"
            label={t("Name")}
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setName(e.target.value)
            }
          />
          <FormHelperText>{errorName}</FormHelperText>
        </StyledFormControl>
        <StyledFormControl fullWidth>
          <TextField
            sx={{ mt: 1 }}
            id="comment_textfield"
            multiline
            label={t("Description")}
            value={comment}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setComment(e.target.value)
            }
          />
          <FormHelperText>{errorComment}</FormHelperText>
        </StyledFormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="white" onClick={onConfirm}>
          {t("Create Event")}
        </Button>
        <Button variant="outlined" color="greyed" onClick={onCancel}>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddEventDialog;
